import type { UserData } from 'chaika-frontend-types/frontend-cms';
import { RoleName } from 'chaika-enums';

export function isAssistant(user: Pick<UserData, 'roles'>): boolean {
    return (user.roles || []).some(({ name }) => name === RoleName.Assistant);
}
